module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1